<template lang="pug">
  
  .creative(:class="classObject"): .content: .client {{ $t('task.creative') }}

</template>

<script>
import cellable from './mixins/cellable'

export default {

  mixins: [cellable],
}
</script>